const AlgoritmaCommon: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-2xl font-bold mb-4">🔥 Algoritma Paling Sering Muncul di Lomba Coding</h2>
            <p className="mb-4">
                Kalau kamu ingin menang lomba coding 🏆, ada beberapa algoritma yang wajib banget kamu kuasai. Algoritma-algoritma ini hampir selalu muncul dalam soal karena kemampuannya menyelesaikan berbagai jenis permasalahan secara efisien. Yuk, kita bahas satu per satu!
            </p>

            <h3 className="text-lg font-semibold mb-2">1️⃣ Greedy, DFS & BFS</h3>
            <p className="mb-4">
                - <strong>Greedy</strong> itu seperti kamu yang selalu ambil keputusan terbaik saat ini tanpa mikirin masa depan 😅. Cocok buat soal penjadwalan, pemilihan koin, dan lain-lain.
                <br />
                - <strong>DFS (Depth-First Search)</strong> menyelam duluan sampai mentok. Sering dipakai untuk soal pohon, pencarian jalur, dan rekursi.
                <br />
                - <strong>BFS (Breadth-First Search)</strong> jalan pelan tapi pasti, lewat level per level. Paling cocok buat cari jarak terpendek di graf tak berbobot.
            </p>

            <h3 className="text-lg font-semibold mb-2">2️⃣ Dynamic Programming (DP)</h3>
            <p className="mb-4">
                DP adalah senjata andalan untuk soal yang punya submasalah berulang 🔁. Bayangin kamu punya banyak puzzle, dan kamu simpan jawaban potongannya supaya nggak ngulang hitung.
                <br />
                Contoh klasik: Fibonacci, Knapsack, Longest Common Subsequence.
                <br />
                Tips: Kuasai <em>top-down (memoization)</em> dan <em>bottom-up (tabulation)</em>!
            </p>

            <h3 className="text-lg font-semibold mb-2">3️⃣ Binary Search & Two Pointer</h3>
            <p className="mb-4">
                - <strong>Binary Search</strong> adalah ninja pencari: cepat, akurat, dan efisien. Cocok untuk array terurut atau masalah “cari nilai optimal”.
                <br />
                - <strong>Two Pointer</strong> teknik dua jari ✌️ yang gerak bareng: satu dari kiri, satu dari kanan. Sering dipakai untuk soal pasangan angka, subarray, dan string.
            </p>

            <h3 className="text-lg font-semibold mb-2">4️⃣ Graph & Shortest Path (Dijkstra, Bellman-Ford)</h3>
            <p className="mb-4">
                Dunia kompetisi coding penuh dengan graf 🌐. Kamu harus bisa memodelkan relasi atau jaringan dalam bentuk simpul dan sisi.
                <br />
                - <strong>Dijkstra</strong>: cepat dan efisien untuk graf dengan bobot non-negatif.
                <br />
                - <strong>Bellman-Ford</strong>: bisa menangani bobot negatif, tapi lebih lambat.
                <br />
                Bonus: Pahami juga <em>Topological Sort</em> dan <em>Union-Find</em>!
            </p>

            <h3 className="text-lg font-semibold mb-2">5️⃣ Sorting & Hashing</h3>
            <p className="mb-4">
                - <strong>Sorting</strong> itu bukan cuma bikin rapi, tapi juga membuka banyak peluang optimasi! Quick Sort, Merge Sort, bahkan Counting Sort bisa muncul.
                <br />
                - <strong>Hashing</strong> sangat berguna buat pencarian cepat. Mau cek apakah suatu nilai sudah muncul? Hash Map solusinya 🔥
            </p>

            <p className="mt-6 font-medium">
                🚀 Menguasai algoritma-algoritma di atas bukan cuma bikin kamu siap lomba, tapi juga bikin kamu berpikir seperti programmer sejati. Siap jadi juara? 💪
            </p>
        </div>
    )
}
export default AlgoritmaCommon